import Link from './Link';
import ChildTemplate from '../_/ChildTemplate';

export default class extends ChildTemplate {
  items = [];
  min = false;

  init() {
    this.setLinks();
  }

  has(agr) {
    return this.permission.has(agr);
  }

  setLinks() {
    this.items = [];
    this.setLinkDashboard();
    this.setLinkSearch();
    this.setLinkTour();
    this.setLinkAgreement();
    this.setLinkTourist();
    this.setLinkLead();
    this.setLinkFinance();
    this.setLinkStatistic();
    this.setLinkTask();
    this.setLinkEvent();
    this.setLinkPhone();
    this.setLinkPartner();
    this.setLinkDictionary();
    this.setLinkCertificate();
    this.setLinkSalary();
  }

  setLinkDashboard() {
    this.items.push(Link.link('Личный кабинет', '/tourclient/admin/', 'mdi-view-dashboard'));
  }

  setLinkSearch() {
    const group = [];
    if (this.has(191)) {
      group.push(Link.link('Туры', '/tourclient/spa/#/search/', 'mdi-map-search'));
    }
    if (this.has(192)) {
      group.push(Link.link('Авиабилеты', '/tourclient/flightsearch/', 'mdi-airplane-takeoff'));
    }
    if (this.has(193)) {
      group.push(Link.link('Отели', '/tourclient/hotelsearch/', 'mdi-home-currency-usd'));
    }
    if (this.has(194)) {
      group.push(Link.link('Страховки', '/tourclient/insurances/', 'mdi-shield-account'));
    }
    if (group.length === 1) {
      this.items.push(group[0]);
    } else if (group.length) {
      this.items.push(Link.group('Поиск', '/tourclient/find/', 'mdi-map-search', group));
    }
  }

  setLinkAgreement() {
    if (this.has(183)) {
      this.items.push(Link.link('Путевки', '/tourclient/spa/#/orders', 'mdi-clipboard-text'));
    }
  }

  setLinkTourist() {
    if (this.has(184)) {
      this.items.push(Link.link('Туристы', '/tourclient/dictionary/#/client', 'mdi-account-multiple'));
    }
  }

  setLinkLead() {
    if (this.has(185)) {
      this.items.push(Link.link('Лиды', '/tourclient/dictionary/#/lead', 'mdi-account-question'));
    }
  }
  setLinkTour() {
    const group = [];
    if (this.has(358)) {
      group.push(Link.link('Конструктор туров', '/app/#/admin/tour', 'mdi-file-find'));
    }

    if (this.has(373)) {
      group.push(Link.link('Продажа туров', '/app/#/tour', 'mdi-file-find'));
    }

    if (this.has(372)) {
      group.push(Link.link('Проведение туров', '/app/#/admin/statistic', 'mdi-file-find'));
    }

    if (this.has(373)) {
      group.push(Link.link('Календарь туров', '/app/#/admin/board', 'mdi-file-find'));
    }

    if (group.length === 1) {
      this.items.push(group[0]);
    } else if (group.length) {
      this.items.push(Link.group('Мои туры', '/tourclient/find/', 'mdi-map-search', group));
    }
  }
  setLinkFinance() {
    if (this.has(186)) {
      this.items.push(Link.link('Финансы', '/tourclient/index.html#/finances', 'mdi-cash-multiple'));
    }
  }

  setLinkStatistic() {
    if (this.has(152)) {
      this.items.push(Link.link('Статистика', '/tourclient/admin/statistic/index.html', 'mdi-chart-bar'));
    }
  }

  setLinkTask() {
    if (this.has(187)) {
      this.items.push(Link.link('Задачи', '/tourclient/admin/tasks/list.html', 'mdi-clipboard-check-outline'));
    }
  }

  setLinkEvent() {
    if (this.has(190)) {
      this.items.push(Link.link('События', '/tourclient/admin/events/index.html', 'mdi-bell'));
    }
  }

  setLinkPhone() {
    if (this.has(218)) {
      this.items.push(Link.link('Звонки', '/tourclient/spa/#/telephony/journal', 'mdi-phone'));
    }
  }

  setLinkPartner() {
    if (this.has(188)) {
      this.items.push(Link.link('Партнеры', '/tourclient/dictionary/#/partner', 'mdi-briefcase'));
    }
  }

  setLinkDictionary() {
    if (this.has(189)) {
      this.items.push(Link.link('Cправочники', '/tourclient/dictionary/#/dictionary', 'mdi-buffer'));
    }
  }

  setLinkCertificate() {
    if (this.has(270)) {
      this.items.push(Link.link('Сертификаты', '/tourclient/index.html#/finances/certificates/search', 'mdi-cash-check'));
    }
  }

  setLinkSalary() {
    if (this.has(339)) {
      this.items.push(Link.link('Зарплата и премии', '/tourclient/dictionary/#/admin/salary', 'mdi-account-cash'));
    }
  }
}
